import React, { useEffect, useState } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { selectAppUser, selectIsReady } from '../../state/selectors/app.js';
import LoginPage from "../../pages/Login/index.jsx";
import Loader from '../loader/loader.jsx';
import Dashboard from './dashboard.js';
import { authenticationService } from '../../services/authenticationService.js';
import appService from '../../services/appService';
import tankService from '../../services/tanksService.js';
import log from '../../services/logger/log.js';
import userCardService from '../../services/userCardService.js';

const mapStateToProps = () => {
    return createStructuredSelector({
        ready: selectIsReady(),
        user: selectAppUser()
    });
}

const Body = (props) => {
    const { ready, user } = props;
    const [isLoginPage, setIsLoginPage] = useState(false);

    useEffect(() => {
        startApp();
    }, []);

    useEffect(() => {
        startApp();
    }, [user])

    const startApp = async () => {
        const u = authenticationService.getCurrentUser();
        if (!u || !u.token) {
            setIsLoginPage(true);
            return;
        }
        else {
            setIsLoginPage(false);
        }

        if(ready) return;

        try {
            await appService.getAppSettings();
            await tankService.getAreasAsync();
            await userCardService.getCardsAsync();
            appService.setAppReady(true);
        }
        catch (error) {
            log.error(`Error durring initializing application. Error: ${JSON.stringify(error)}`)
        }
    }

    if (isLoginPage) {
        return (
            <main>
                <Switch>
                    <Route exact path="/login" component={LoginPage} />
                    <Redirect from="/" to="/login" />
                </Switch>
            </main>
        )
    }

    if (!ready) {
        return (
            <main>
                <Loader />
            </main>
        )
    }

    return (
        <main>
            <Dashboard/>
        </main>
    );
}


export default connect(
    mapStateToProps
)(Body);